import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGenericQuery } from '../../../core/api/reactQuery';
import { populateDataLayerGA } from '../../../core/gtm';
import { useAccessControlStore } from '../../../core/stores/accessControlStore';
import { requestMe } from '../queries/fetchAuth';
import { useUserStore } from '../stores/authStore';

export function useMe(redirectOnFail = true) {
  const navigate = useNavigate();
  const { setUser } = useUserStore();
  const { setPermissions, setPlatformModules } = useAccessControlStore();
  const { data, isLoading, isSuccess } = useGenericQuery(
    ['me'],
    requestMe,
    setUser
  );

  useEffect(() => {
    if (isSuccess && data) {
      
      if (data.situation === 'guest' && redirectOnFail) {
        navigate('/logout');
        window.location.reload();
      }

      const modulesGranted = data?.permissions?.modulesGranted || [];
      setPermissions(modulesGranted);

      // Lista de hrefs liberados vinda do backend. Se ausente, mantém null
      // (o guard trata null como "libera tudo", evitando trancar usuários).
      setPlatformModules(data?.permissions?.platformModules ?? null);

      populateDataLayerGA(data);
    }
  }, [isSuccess, data]);

  return {
    data,
    isLoading,
  };
}
